// extracted by mini-css-extract-plugin
export default {"Container":"team_Container__H+UY9","staffGrid":"team_staffGrid__umf1I"};